// extracted by mini-css-extract-plugin
export default {"chatNotification":"Header_chatNotification__J-L5f"};